module.exports = "pegasus_template/assets/themelp1/tickets/103.png";